import { render, staticRenderFns } from "./SectionBuilder.vue?vue&type=template&id=4cf78c8a&scoped=true"
import script from "./SectionBuilder.vue?vue&type=script&lang=js"
export * from "./SectionBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf78c8a",
  null
  
)

export default component.exports